import './index.css';
import { Dropdown } from './dropdown.js';
export { Dropdown } from './dropdown.js';
/**
 * @deprecated use named import instead
 */

var DefaultDropdown = Dropdown;
export { DefaultDropdown as default };
